<figcaption>
    @if (media.imageRetouched) {
        <p data-testid="imageRetouched" class="image-retouched" i18n="@@hermes.image_retouched">Retouched</p>
    }
    @if (media.caption) {
        <p data-testid="caption" class="caption">{{ media.caption }}</p>
    }
    @if (media.credits) {
        <p data-testid="credits" class="credits">{{ media.credits }}</p>
    }
</figcaption>
